var map = {
	"./developer.jpg": 37,
	"./logo-GitHub.png": 38,
	"./logo-LinkedIn.png": 39,
	"./screeenshot_aerobots-vr.png": 40,
	"./screenshot_bookmark-organizer.png": 41,
	"./screenshot_calliope.png": 42,
	"./screenshot_spaced-repetition.png": 43
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;